import _sfc_main from "./PasswordDialog.vue2.mjs";
/* empty css                     */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.TuiDialog, { attrs: { "title": _setup.t("The room is encrypted"), "modal": true, "show-close": false, "close-on-click-modal": false, "width": "420px", "append-to-body": true, "confirm-button": _setup.t("Join"), "cancel-button": _setup.t("Cancel") }, on: { "confirm": _setup.joinRoom, "cancel": _setup.cancelInputPassword }, scopedSlots: _vm._u([{ key: "footer", fn: function() {
    return [_c("span", [_c(_setup.TuiButton, { staticClass: "button", attrs: { "size": "default", "disabled": _setup.isJoinButtonDisable }, on: { "click": _setup.joinRoom } }, [_vm._v(" " + _vm._s(_setup.t("Join")) + " ")]), _c(_setup.TuiButton, { staticClass: "button", attrs: { "size": "default", "type": "primary" }, on: { "click": _setup.cancelInputPassword } }, [_vm._v(" " + _vm._s(_setup.t("Cancel")) + " ")])], 1)];
  }, proxy: true }]), model: { value: _setup.isShowPasswordContainer, callback: function($$v) {
    _setup.isShowPasswordContainer = $$v;
  }, expression: "isShowPasswordContainer" } }, [_c(_setup.TuiInput, { attrs: { "model-value": _setup.inputPassword, "placeholder": _setup.t("Please enter the password"), "type": "password", "maxlength": "32", "theme": "white" }, on: { "input": function($event) {
    _setup.inputPassword = $event;
  } }, scopedSlots: _vm._u([{ key: "suffixIcon", fn: function() {
    return [_c(_setup.svgIcon, { staticClass: "svg-icon", attrs: { "icon": _setup.CloseInputIcon }, on: { "click": function($event) {
      _setup.inputPassword = "";
    } } })];
  }, proxy: true }]) })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ab8ed39b"
);
const PasswordDialog = __component__.exports;
export {
  PasswordDialog as default
};
